import { render } from "./fb1.vue?vue&type=template&id=bf691b88&scoped=true"
import script from "./fb1.vue?vue&type=script&lang=js"
export * from "./fb1.vue?vue&type=script&lang=js"

import "./fb1.vue?vue&type=style&index=0&id=bf691b88&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf691b88"]])

export default __exports__